import { Component, ViewEncapsulation } from '@angular/core';

/**
 * Primary / secondary action column for forms using outline fields (Contact pattern).
 * Mark actions with `crowdctrlFormSecondaryAction` and `crowdctrlFormPrimaryAction` on projected controls.
 */
@Component({
  selector: 'crowdctrl-form-submit-bar',
  standalone: true,
  templateUrl: './form-submit-bar.component.html',
  styleUrl: './form-submit-bar.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class FormSubmitBarComponent {}
